import { CheckCircleFilled, EnvironmentOutlined } from '@ant-design/icons';
import { Radio } from 'antd';
import dayjs from 'dayjs';

import type { NClients } from '@app/types';

import type { FC } from 'react';

interface SimilarClientOptionProps {
  client: NClients.ModelClientLite;
}

const formatBirthDate = (date: string | null): string =>
  date ? dayjs(date).format('DD.MM.YYYY') : '';

const buildContacts = (phone: string | null, email: string | null): string =>
  [phone, email].filter(Boolean).join(', ');

export const SimilarClientOption: FC<SimilarClientOptionProps> = ({
  client,
}) => {
  const { Id, NameFirst, NameLast, DateBirth, Phone1, Email, Branch } = client;
  const fullName = [NameLast, NameFirst].filter(Boolean).join(' ').trim();
  const birthDate = formatBirthDate(DateBirth);
  const contacts = buildContacts(Phone1, Email);

  return (
    <Radio className="LeadsWriteFirstModal__client" value={Id}>
      <span className="LeadsWriteFirstModal__client-body">
        <span className="LeadsWriteFirstModal__client-name">
          {client.IsPhoneVerified && (
            <CheckCircleFilled className="LeadsWriteFirstModal__client-verified" />
          )}
          {fullName || 'Без имени'}
          {birthDate && (
            <span className="LeadsWriteFirstModal__client-birth">
              , {birthDate}
            </span>
          )}
        </span>

        {contacts && (
          <span className="LeadsWriteFirstModal__client-contacts">
            {contacts}
          </span>
        )}

        {Branch && (
          <span className="LeadsWriteFirstModal__client-branch">
            <EnvironmentOutlined />
            {Branch}
          </span>
        )}
      </span>
    </Radio>
  );
};
